module.exports = __webpack_public_path__ + "img/mens-pants-500x500.36fbc28f.jpg";